'use client'

import { Row } from '@repo/ui/components'
import { Icon, type IconNames } from '@repo/ui/components/icon'
import { Link } from '../../i18n/navigation'

interface LandingFooterSocialSectionProps {
  className?: string
  gap?: 'sm' | 'md' | 'lg' | 'xl'
  iconSize?: 'xs' | 'sm' | 'md' | 'lg'
  socialLinks: { href: string; icon: IconNames }[]
}

export const LandingFooterSocialSection = ({
  className = '',
  gap = 'md',
  iconSize = 'md',
  socialLinks,
}: LandingFooterSocialSectionProps) => {
  const gapConfig = {
    sm: 'gap-sm',
    md: 'gap-md',
    lg: 'gap-lg',
    xl: 'gap-xl',
  }

  return (
    <Row className={`w-fit ${gapConfig[gap]} ${className}`}>
      {socialLinks.map((link) => (
        <Link key={link.icon} href={link.href} target='_blank'>
          <Icon
            className='flex'
            color='fill-base-surface-100'
            name={link.icon as IconNames}
            size={iconSize}
          />
        </Link>
      ))}
    </Row>
  )
}
